// Per-org batch transcription/diarization provider (server: POST
// /admin/transcription-provider). Pure so the payload rules are unit-tested:
// AssemblyAI takes no model; a blank model means "use the binding's default".
export type TranscriptionProvider = 'assemblyai' | 'openrouter' | 'deepgram'

export const DEFAULT_TRANSCRIPTION_PROVIDER: TranscriptionProvider = 'assemblyai'

export const TRANSCRIPTION_PROVIDER_OPTIONS: Array<{
  value: TranscriptionProvider
  label: string
  // null → the provider has no model knob (AssemblyAI is pinned server-side).
  defaultModel: string | null
}> = [
  { value: 'assemblyai', label: 'AssemblyAI (default)', defaultModel: null },
  { value: 'openrouter', label: 'OpenRouter (audio LLM)', defaultModel: 'google/gemini-2.5-flash' },
  { value: 'deepgram', label: 'Deepgram', defaultModel: 'nova-2' },
]

export const providerSupportsModel = (provider: TranscriptionProvider): boolean =>
  TRANSCRIPTION_PROVIDER_OPTIONS.find(o => o.value === provider)?.defaultModel !== null

export const defaultModelFor = (provider: TranscriptionProvider): string | null =>
  TRANSCRIPTION_PROVIDER_OPTIONS.find(o => o.value === provider)?.defaultModel ?? null

export const coerceTranscriptionProvider = (
  value: string | null | undefined,
): TranscriptionProvider =>
  TRANSCRIPTION_PROVIDER_OPTIONS.some(o => o.value === value)
    ? (value as TranscriptionProvider)
    : DEFAULT_TRANSCRIPTION_PROVIDER

export interface TranscriptionProviderUpdate {
  organizationId: string
  provider: TranscriptionProvider
  model: string | null
}

export function buildTranscriptionProviderUpdate(
  organizationId: string,
  provider: TranscriptionProvider,
  modelInput: string,
): TranscriptionProviderUpdate {
  const model = providerSupportsModel(provider) ? modelInput.trim() || null : null
  return { organizationId, provider, model }
}
